<template>
    <div>
      <div class="card-body p-0" v-if="errors.length">
        <base-alert type="danger">
          <b>You have the following error(s):</b>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
      </div>
      <h2>
        Setup product for Zalora
        <div class="float-right">
          <a-button
            type="primary"
            class="btn btn-primary float-right btn-sm border-sm mr-0"
            v-if="this.$attrs.actionStatus == 'Edit'"
            :loading="saveLoading"
            @click.prevent="updateParams"
            >Update</a-button
          >
          <a-button
            type="primary"
            class="btn btn-primary float-right btn-sm border-sm mr-0"
            v-else-if="this.$attrs.actionStatus != 'Edit'"
            :loading="saveLoading"
            @click.prevent="saveParams"
            >Save</a-button
          >
          <a-button
            type="primary"
            class="btn float-right mr-0 bg-white text-dark mr-3 btn-sm"
            @click.prevent="$emit('closeProductFrom', null)"
            >Cancel</a-button
          >
        </div>
      </h2>
      <div class="row mt-4 overflow-auto" style="height: 44rem">
        <div class="col-md-12">
          <a-collapse
            v-model="activeKey"
            expand-icon-position="right"
            class="border-0 bg-white"
          >
            <a-collapse-panel key="1" header="01. Basic Information" :style="customStyle">
              <base-input
                v-model="ZaloraTemplate.Attributes.name"
                input-classes="form-control form-control-sm"
                label="Product name"
                required
              />
              <div class="form-group has-label">
                <label class="form-control-label"> Select Category<span>*</span></label>
                <a-cascader
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children',
                    isLeaf: 'leaf',
                  }"
                  :options="categories"
                  placeholder="Please select category"
                  :show-search="{ filter }"
                  autocomplete="off"
                  @change="onChangeCategory"
                  v-model="ZaloraTemplate.cascader_category"
                />
              </div>
              <div class="row" v-if="ZaloraTemplate.cascader_category.length >= 1">
                <div
                  class="col-md-4"
                  v-for="(att, attIndex) in attributes"
                  v-if="
                    att.isMandatory &&
                    att.name != 'quantity' &&
                    att.name != 'price' &&
                    att.name != 'name' &&
                    att.name != 'sku_supplier_source' &&
                    att.name != 'box_height_config' &&
                    att.name != 'weight_config' &&
                    attIndex != sizeAttributeIndex
                  "
                >
                  <base-input
                    v-if="att.inputType == 'textfield' || att.inputType == 'richtext'"
                    v-model="ZaloraTemplate.Attributes[att.id]"
                    :placeholder="att.label"
                    :value="
                      ZaloraTemplate.Attributes[att.id] != null
                        ? (ZaloraTemplate.Attributes[att.id] =
                            ZaloraTemplate.Attributes[att.id])
                        : (ZaloraTemplate.Attributes[att.id] = null)
                    "
                    input-classes="form-control form-control-sm"
                    :label="att.label"
                    required
                  />
                  <base-input
                    v-else-if="att.inputType == 'date'"
                    v-model="ZaloraTemplate.Attributes[att.id]"
                    :value="
                      ZaloraTemplate.Attributes[att.name] != null
                        ? (ZaloraTemplate.Attributes[att.name] =
                            ZaloraTemplate.Attributes[att.name])
                        : (ZaloraTemplate.Attributes[att.name] = null)
                    "
                    type="date"
                    input-classes="form-control form-control-sm"
                    :label="att.label"
                    required
                  />
                  <div
                    class="form-group has-label"
                    v-else-if="
                      (att.inputType == 'multiselect' ||
                        att.inputType == 'multienuminput' ||
                        att.inputType == '' ||
                        att.inputType == 'dropdown' ||
                        att.inputType == 'singleselect') &&
                        att.name != 'brand'  
                    "
                  >
                    <label class="form-control-label"> {{ att.label }}<span>*</span></label>
                    <div
                      v-if="
                        ZaloraTemplate.Attributes[att.name] != null
                          ? (ZaloraTemplate.Attributes[att.name] =
                              ZaloraTemplate.Attributes[att.name])
                          : (ZaloraTemplate.Attributes[att.name] = null)
                      "
                    ></div>
                    <template>
                      <select
                        class="ant-select-selection ant-select-selection--single select-custom"
                        v-model="ZaloraTemplate.Attributes[att.id]"
                        :show-search="{ filter }"
                        :placeholder="'Select ' + att.label"
                      >
                        <!-- part 4 -->
                        <option
                          v-for="data in att.options"
                          :key="zStatus == 'Edit' ? data.id : data.name"
                          :value="zStatus == 'Edit' ? data.id : data.name"
                        >
                          {{ data.name }}
                        </option>
                      </select>
                    </template>
                  </div>
                
                  <div class="form-group has-label" v-else-if="att.name == 'brand'">
                    <label class="form-control-label"> {{ att.label }}<span>*</span></label>
                    <div
                      hidden
                      v-if="
                        ZaloraTemplate.Attributes[att.name] != null
                          ? (ZaloraTemplate.Attributes[att.name] =
                              ZaloraTemplate.Attributes[att.name])
                          : (ZaloraTemplate.Attributes[att.name] = null)
                      "
                    ></div>
                    <template>
                      <a-select
                        v-model="ZaloraTemplate.Attributes.brandId"
                        show-search
                        :placeholder="'Select ' + att.label"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        @search="fetchBrand"
                        @change="handleBrandChange"
                      >
                        <a-spin
                          v-if="fetching"
                          slot="notFoundContent"
                          size="small"
                          class="d-flex justify-content-center"
                        />
                        <a-select-option
                          v-for="(data, index) in tempBrands.slice(0, 100)"
                          :key="index"
                          :value="data.id"
                          >{{ data.name }}
                        </a-select-option>
                      </a-select>
                    </template>
                  </div>
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel
              key="2"
              header="02. Detailed Description"
              :style="customStyle"
            >
              <div class="form-group has-label">
                <label class="form-control-label"> Short Description<span> *</span></label>
                <quill-editor
                  ref="myQuillEditor"
                  v-model="ZaloraTemplate.Attributes.short_description"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                />
              </div>
              <div class="form-group has-label">
                <label class="form-control-label">Description<span>*</span></label>
                <quill-editor
                  ref="myQuillEditor"
                  v-model="ZaloraTemplate.Attributes.description"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
                />
              </div>
            </a-collapse-panel>
            <a-collapse-panel
              key="3"
              header="03. Price & Stock"
              v-if="ZaloraTemplate.cascader_category.length >= 1"
              :style="customStyle"
            >
              <div class="row" v-if="productDetails.product_type != 'M'">
                <div class="col-md-3 p-1 pl-3">
                  <base-input
                    v-model="ZaloraTemplate.price"
                    input-classes="form-control form-control-sm"
                    min="1"
                    step="0.01"
                    type="number"
                    label="Price"
                    required
                  />
                </div>
                <div class="col-md-3 p-1">
                  <base-input
                    v-model="ZaloraTemplate.quantity"
                    input-classes="form-control form-control-sm"
                    min="0"
                    type="number"
                    label="Stock"
                    required
                    disabled
                  />
                </div>
                <div class="col-md-3 p-1">
                  <base-input
                    v-model="ZaloraTemplate.SellerSku"
                    input-classes="form-control form-control-sm"
                    label="Seller Sku"
                    required
                    minlength="3"
                    disabled
                  />
                </div>
              </div>
              <div class="row" v-if="productDetails.product_type == 'M'">
                <div class="col-md-12">
                  <div class="form-inline mb-2 p-1">
                    <label class="form-control-label mr-2">Price:</label>
                    <base-input
                      v-model="ZaloraTemplate.price"
                      input-classes="form-control form-control-sm"
                      min="1"
                      step="0.01"
                      type="number"
                      required
                    />
                  </div>
                  <div class="table-responsive">
                    <table class="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th v-if="sizeAttributeIndex >= 0">Size</th>
                          <th>Seller SKU</th>
                        </tr>
                      </thead>
                      <tbody>
                        -<tr
                          v-for="(subProduct, subProductIndex) in ZaloraTemplate.Skus"
                          v-bind:key="subProductIndex"
                        >
                        <td v-if="sizeAttributeIndex>=0">
                            <a-select 
                                v-model="ZaloraTemplate.Skus[subProductIndex].size"
                                show-search
                                placeholder="Select Size">
                                  <a-select-option v-for="data in attributes[sizeAttributeIndex].options" :key="data.name" :value="data.name">{{data.name}}
                                  </a-select-option>
                            </a-select>
                        </td>
                          <td>
                            <base-input
                              v-model="ZaloraTemplate.Skus[subProductIndex].SellerSku"
                              input-classes="form-control form-control-sm"
                              required
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel key="4" header="04. Delivery" :style="customStyle">
              <div class="row">
                <div class="col p-1 pl-3">
                  <base-input
                    v-model="ZaloraTemplate.weight_config"
                    input-classes="form-control form-control-sm"
                    min="0.01"
                    step="0.01"
                    type="number"
                    label="Weight (kg)"
                    required
                  />
                </div>
                <div class="col p-1">
                  <base-input
                    v-model="ZaloraTemplate.box_height_config"
                    input-classes="form-control form-control-sm"
                    min="0.01"
                    step="0.01"
                    type="number"
                    label="Height (cm)"
                    required
                  />
                </div>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </div>
</template>
  <script>
  import axios from "axios";
  import HTTPRequest from "../../controllers/httpRequest.js";
  import ValidateField from "../../components/validateFormUtils.js";
  import secureStorage from "../../controllers/secureStorage.js";
  import Quill from "quill";
  import { mapState } from "vuex";
  var component_x;
  export default {
    computed: {
      ...mapState(["endPoint", "profileId", "serverType", "publicUrl"]),
    },
    mounted: async function () {
      component_x = this;
      this.imageUrl = this.publicUrl + "product_images";
      this.accessToken = this.$attrs.ZaloraAccessToken;
      var arr = this.$attrs.productIntegrationData;
      var colors = await HTTPRequest.getRequest(
        component_x.endPoint + "colors/get_valid_colors",
        null
      );

      var productColor = colors.find(color => color.id == arr.color_id);

      var sizes = await HTTPRequest.getRequest(
        component_x.endPoint + "sizes/get_valid_sizes",
        null
      );

      var productSize = sizes.find(size => size.id == arr.size_id);
     
      this.salesChannelId = this.$attrs.salesChannelId;
      if (this.$attrs.actionStatus == "Edit") {
        this.zStatus = this.$attrs.actionStatus;
        this.productDetails = arr;
        this.ZaloraTemplate = arr.zaloraParams;
        this.getAttributes(true);
      } else {
        if (arr.product_type == "M") {
          var response = await HTTPRequest.getRequest(
            this.endPoint +
              "marketplace_integrations/get_sub_product_details?id=" +
              arr.id +
              "&site_id=" +
              this.$attrs.siteId +
              "&sublocation_id=" +
              this.$attrs.selectedSublocationId +
              "&percent=" +
              this.$attrs.inventoryPercentage,
            null
          );
          arr.sub_products = response;
          this.productDetails = arr;
        } else {
          this.ZaloraTemplate.SellerSku = arr.stock_no;
          if (this.ZaloraTemplate.SellerSku.split("").length < 3) {
            this.errors = "Please Change the Product Stock no. (min of 3 characters)".split(
              ","
            );
          }
          this.productDetails = arr;
          this.getProductAvailableQuantity(arr.id);
        }
        this.ZaloraTemplate.price = arr.retail_price;
        this.ZaloraTemplate.Attributes.name = arr.name;
        this.ZaloraTemplate.weight_config = arr.weight;
        this.ZaloraTemplate.box_height_config = arr.height;
      }
      this.getCategories();
    },
    data() {
      return {
        accessToken: null,
        shopId: null,
        saveLoading: false,
        categories: [],
        imageUrl: null,
        errors: [],
        activeKey: ["1", "2", "3", "4"],
        customStyle:
          "margin-bottom: 24px;border: 1px solid #dee2e6!important;background-color: #fafafa;",
        attributes: [],
        brands: [],
        tempBrands: [],
        fetching: false,
        productDetails: [],
        sizeAttributeIndex: -1,
        ZaloraTemplate: {
          PrimaryCategory: null,
          Attributes: {
            name: null,
            short_description: null,
            description: null,
            brandId: null,
          },
          variation:null,
          Skus: [],
          SellerSku: null,
          TaxClass: null,
          quantity: null,
          price: null,
          box_height_config: null,
          weight_config: null,
          cascader_category: [],
        },
        tempBrandValue: null,
        nextBrandSearch: false,
        salesChannelId: null,
        zStatus: null,
      };
    },
    methods: {
      // part 2
      getCategories: async function () {
        var response = await HTTPRequest.postRequest(
          this.endPoint + "zalora_integrations/categories",
          null,
          { access_token: this.accessToken }
        );
        if (response["error"] == undefined) {
          this.categories = response;
        } else {
          this.errors = response.split(",");
        }
      },
  
      onChangeCategory(value) {
        if (value.length > 0) {
          this.getAttributes();
        }
      },
  
      filter(inputValue, path) {
        return path.some(
          (option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
        );
      },
  
      // part 3
      getAttributes: async function (status) {
        this.ZaloraTemplate.PrimaryCategory = this.ZaloraTemplate.cascader_category[
          this.ZaloraTemplate.cascader_category.length - 1
        ];
        var response = await HTTPRequest.postRequest(
          this.endPoint + "zalora_integrations/attributes",
          null,
          {
            access_token: this.accessToken,
            category_id: this.ZaloraTemplate.cascader_category[
              this.ZaloraTemplate.cascader_category.length - 1
            ],
          }
        );
  
        if (response["error"] == undefined) {
          this.attributes = response;
  
          if (this.brands.length == 0) {
            this.getBrands();
          }
          if (status == undefined) {
            this.ZaloraTemplate.Attributes = {
              name:
                this.ZaloraTemplate.Attributes.name != null
                  ? this.ZaloraTemplate.Attributes.name
                  : this.productDetails.name != null
                  ? this.productDetails.name
                  : null,
              short_description:
                this.ZaloraTemplate.Attributes.short_description != null
                  ? this.ZaloraTemplate.Attributes.short_description
                  : this.productDetails.short_description != null
                  ? this.productDetails.short_description
                  : null,
              description:
                this.ZaloraTemplate.Attributes.description != null
                  ? this.ZaloraTemplate.Attributes.description
                  : this.productDetails.description != null
                  ? this.productDetails.description
                  : null,
            };
          }
          if (this.productDetails.product_type == "M") {
            this.getVariationBaseOnSelectedCategory(status);
          }
        } else {
          if (status == undefined) {
            this.ZaloraTemplate.Attributes = {
              name:
                this.ZaloraTemplate.Attributes.name != null
                  ? this.ZaloraTemplate.Attributes.name
                  : this.productDetails.name != null
                  ? this.productDetails.name
                  : null,
              short_description:
                this.ZaloraTemplate.Attributes.short_description != null
                  ? this.ZaloraTemplate.Attributes.short_description
                  : this.productDetails.short_description != null
                  ? this.productDetails.short_description
                  : null,
              description:
                this.ZaloraTemplate.Attributes.description != null
                  ? this.ZaloraTemplate.Attributes.description
                  : this.productDetails.description != null
                  ? this.productDetails.description
                  : null,
            };
          }
          this.attributes = [];
          this.errors = response["error"].split(",");
        }
      },
  
      onEditorBlur(quill) {
        //console.log('editor blur!', quill)
      },
      onEditorFocus(quill) {
        //console.log('editor focus!', quill)
      },
      onEditorReady(quill) {
        //console.log('editor ready!', quill)
      },
      onEditorChange({ quill, html, text }) {
        //console.log('editor change!', quill, html, text)
        this.ZaloraTemplate.Attributes.short_description = html;
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text
            .toLowerCase()
            .indexOf(input.toLowerCase()) >= 0
        );
      },
      getBrands: async function () {
        this.nextBrandSearch = true;
        this.ZaloraTemplate.Attributes;
        let search = "";
        this.tempBrandValue != null ? (search = this.tempBrandValue) : "";
        var response = await HTTPRequest.postRequest(
          this.endPoint + "zalora_integrations/brands",
          null,
          { access_token: this.accessToken, name: search }
        );
        if (response["error"] == undefined) {
          if (response.length < 500) {
            this.tempBrands = response;
            this.nextBrandSearch = false;
          } else {
            this.brands = response;
            this.tempBrands = response;
            this.nextBrandSearch = false;
          }
        } else {
          this.errors = response["error"].split(",");
        }
      },
  
      fetchBrand(value) {
        this.fetching = true;
        this.tempBrands = this.searchBrand(value);
        if (this.tempBrands.length < 1 && !this.nextBrandSearch) {
          this.tempBrandValue = value;
          this.getBrands();
        }
      },
      handleBrandChange(value) {
        this.ZaloraTemplate.Attributes.brand = value;
        this.tempBrandValue = value;
        this.fetchBrandNextCall = false;
        this.tempBrands = [];
        this.fetching = false;
      },
      handleOtherSelectChange(value, data) {
        console.log(value, data);
      },
      searchBrand(value) {
        return this.brands.filter((brand) => {
          return !value || brand.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
        });
      },
  
      getProductAvailableQuantity: async function (id) {
        var response = await HTTPRequest.getRequest(
          this.endPoint +
            "marketplace_integrations/get_product_stock?id=" +
            id +
            "&site_id=" +
            this.$attrs.siteId +
            "&sublocation_id=" +
            this.$attrs.selectedSublocationId,
          null
        );
        if (response != null) {
          if (response["error"] == undefined) {
            this.ZaloraTemplate.quantity =
              (response.available_quantity * this.$attrs.inventoryPercentage) / 100;
            this.ZaloraTemplate.quantity =
              this.ZaloraTemplate.quantity < 0 ? 0 : this.ZaloraTemplate.quantity;
          } else {
            this.ZaloraTemplate.quantity = 0;
          }
        } else {
          this.ZaloraTemplate.quantity = 0;
        }
      },
      getVariationBaseOnSelectedCategory(status) {
        var size_index = this.attributes.findIndex((x) => x.name == "size");
        if (size_index >= 0) {
          this.sizeAttributeIndex = size_index;
        } else {
          this.sizeAttributeIndex = -1;
        }
        if (status == undefined) {
          this.ZaloraTemplate.Skus = [];
          this.productDetails.sub_products.forEach((value, index) => {
            var array = {
              SellerSku: value.stock_no,
              quantity: value.available_quantity,
              price: value.retail_price,
            };
            if (index != 0) {
              array.SellerSku = value.stock_no + "-" + index;
            }
            if (component_x.sizeAttributeIndex >= 0) {
              array.size = value.size_name;
            }
           
            component_x.ZaloraTemplate.Skus.push(array);
          });
        }
      },
      validation() {
        this.errors = [];
        this.errors.push(
          ValidateField.required("Category", this.ZaloraTemplate.PrimaryCategory)
        );
        // for (const name in this.ZaloraTemplate.Attributes) {
        //   this.errors.push(
        //     ValidateField.required(name, this.ZaloraTemplate.Attributes[name])
        //   );
        // }
        if (this.productDetails.product_type == "M") {
          this.ZaloraTemplate.Skus.forEach((value, index) => {
            for (const name in value) {
              if (name != "quantity") {
                this.errors.push(
                  ValidateField.required(
                    name + " for row number " + (index + 1),
                    value[name]
                  )
                );
              }
            }
          });
        } else {
          this.errors.push(
            ValidateField.required("SellerSku", this.ZaloraTemplate.SellerSku)
          );
          this.errors.push(ValidateField.required("Price", this.ZaloraTemplate.price));
        }
        this.errors.push(
          ValidateField.required("Package Height", this.ZaloraTemplate.box_height_config)
        );
        this.errors.push(
          ValidateField.required("Package Weight", this.ZaloraTemplate.weight_config)
        );
        this.errors.push(
          ValidateField.greaterThanZero(
            "Package Height",
            this.ZaloraTemplate.box_height_config
          )
        );
        this.errors.push(
          ValidateField.greaterThanZero("Package Weight", this.ZaloraTemplate.weight_config)
        );
        this.errors = this._.compact(this.errors);
        return this.errors.length;
      },
      async saveParams() {
        if (!this.validation()) {
          this.saveLoading = true;
          this.productDetails.zaloraParams = this.ZaloraTemplate;
          this.productDetails.defaultPrice = this.defaultPrice;
          this.imageUrl + "/" + this.productDetails.filename;
          if (this.salesChannelId > 0) {
            var post_request = await HTTPRequest.postRequest(
              this.endPoint + "zalora_integrations",
              null,
              {
                sales_channel_id: this.salesChannelId,
                product_details: this.productDetails,
              }
            );
            if (post_request["error"] == undefined) {
              this.$notification["success"]({
                message: "Success",
                Description: "successfully Created.",
              });
              this.$emit("getPostedProductData", null);
              this.$emit("allProductsData", null);
              this.$emit("closeProductFrom", null);
            } else {
              component_x.errors.push(post_request["error"]);
            }
          } else {
            this.$emit("integrationAddProduct", this.productDetails);
          }
          this.saveLoading = false;
        }
      },
      async updateParams() {
        if (!this.validation()) {
          this.saveLoading = true;
          this.productDetails.zaloraParams = this.ZaloraTemplate;
          this.productDetails.image_url =
            this.imageUrl + "/" + this.productDetails.filename;
          if (this.salesChannelId > 0) {
            var post_request = await HTTPRequest.putRequest(
              this.endPoint + "zalora_integrations/" + this.salesChannelId,
              null,
              { product_details: this.productDetails }
            );
            if (post_request["error"] == undefined) {
              this.$notification["success"]({
                message: "Success",
                Description: "successfully Updated.",
              });
              this.$emit("getPostedProductData", null);
              this.$emit("allProductsData", null);
              this.$emit("closeProductFrom", null);
            } else {
              component_x.errors.push(post_request["error"]);
            }
          } else {
            this.$emit("integrationUpdateProduct", this.productDetails);
          }
          this.saveLoading = false;
        }
      },
    },
  };
  </script>
  